<div class="flex flex-col w-full min-w-0 absolute top-16 sm:top-[4.5rem] overflow-hidden h-[calc(100%-64px)] sm:h-[calc(100%-4.5rem)] bg-gray-50 dark:bg-gray-900">

    <!-- Górna nawigacja admina -->
    <header class="flex-shrink-0 bg-card border-b border-gray-200 dark:border-gray-800 shadow-sm">
        <div class="flex items-center gap-4 px-4 sm:px-6 h-14">
            <div class="text-lg font-extrabold tracking-tight leading-none whitespace-nowrap">
                Administracja
            </div>

            <nav class="flex-1 flex items-center gap-1 overflow-x-auto">
                <a *ngFor="let panel of panels; trackBy: trackByFn"
                    [routerLink]="panel.id"
                    (click)="goToPanel(panel.id)"
                    class="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors"
                    [ngClass]="selectedPanel === panel.id
                        ? 'bg-primary-50 dark:bg-hover text-primary dark:text-primary-500'
                        : 'text-hint hover:bg-gray-100 dark:hover:bg-hover'">
                    <mat-icon class="icon-size-5"
                        [ngClass]="selectedPanel === panel.id ? 'text-primary dark:text-primary-500' : 'text-hint'"
                        [svgIcon]="panel.icon"></mat-icon>
                    <span>{{ panel.title }}</span>
                    <span *ngIf="panel.badge && panel.badge() > 0"
                        class="px-1.5 py-0.5 text-xs font-bold rounded-full text-white"
                        [ngClass]="panel.badgeClass || 'bg-red-500'">
                        {{ panel.badge() }}
                    </span>
                </a>
            </nav>

            <div class="text-xs text-secondary whitespace-nowrap hidden sm:block">v{{ version }}</div>
        </div>
    </header>

    <!-- Treść panelu (pełna szerokość, własny scroll) -->
    <main class="flex-auto overflow-y-auto">
        <div class="p-4 sm:p-6">
            <router-outlet></router-outlet>
        </div>
    </main>
</div>
